import { RootState } from '../../../state/store';
import { StudiesState } from '../model/StudiesState';

export const getStudiesSelector = ({ studies }: RootState): StudiesState => studies;
